import { Group, Text } from '@mantine/core';
import { CarouselLayout, GridLayout, isTrackReference, useRoomInfo, useTracks } from '@livekit/components-react';
import { RoomEvent, Track } from 'livekit-client';

import classes from './egress-page.module.css';
import { CallDuration } from '@/conference/call-duration';
import { ParticipantTile } from '@/conference/call/participant-tile';
import { useSpeakerTrack } from '@/conference/call/speaker-track';
import { isSameTrackRef } from '@/conference/call/track-refs';
import { ReactionsOverlay } from '@/conference/reactions';

export function EgressComposite({ layout }: Readonly<{ layout: string }>) {
    const { name: roomName } = useRoomInfo();
    const tracks = useTracks(
        [
            { source: Track.Source.Camera, withPlaceholder: true },
            { source: Track.Source.ScreenShare, withPlaceholder: false },
        ],
        { updateOnlyOn: [RoomEvent.ActiveSpeakersChanged], onlySubscribed: false }
    ).filter((track) => !track.participant.isLocal);
    const screenShare = tracks.find((track) => isTrackReference(track) && track.source === Track.Source.ScreenShare);
    const speakerTrack = useSpeakerTrack(tracks);

    const stageTrack = screenShare ?? speakerTrack;
    const filmstripTracks = tracks.filter((track) => !isSameTrackRef(track, stageTrack));
    const speakerLayout = Boolean(screenShare) || layout.includes('speaker');

    return (
        <div className={classes.canvas}>
            <header className={classes.header}>
                <Group className={classes.chip} gap="var(--spacing-2)" wrap="nowrap">
                    <Text truncate fw={500} size="sm">
                        {roomName}
                    </Text>
                    <CallDuration />
                </Group>
            </header>
            {speakerLayout ? (
                <div className={classes.stage}>
                    <div className={classes.speaker}>{stageTrack && <ParticipantTile trackRef={stageTrack} />}</div>
                    {filmstripTracks.length > 0 && (
                        <div className={classes.filmstrip}>
                            <CarouselLayout orientation="vertical" tracks={filmstripTracks}>
                                <ParticipantTile />
                            </CarouselLayout>
                        </div>
                    )}
                </div>
            ) : (
                <div className={classes.stage}>
                    <GridLayout className={classes.grid} tracks={tracks}>
                        <ParticipantTile />
                    </GridLayout>
                </div>
            )}
            <ReactionsOverlay silent />
        </div>
    );
}
